module.exports = __webpack_public_path__ + "static/media/templatetwo2.18879125.png";